var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeAktiv(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.989 15.9688C35.989 17.0938 35.0515 17.975 33.9889 17.975H31.9888L32.0326 27.9813C32.0326 28.1562 32.0201 28.3187 32.0013 28.4875V29.5C32.0013 30.8813 30.8825 32 29.5012 32H28.5012C28.4324 32 28.3637 31.9438 28.2949 31.9937C28.2074 31.9438 28.1199 32 28.0324 32H24.501C23.1197 32 22.0009 30.8813 22.0009 29.5V24C22.0009 22.8937 21.1071 22 20.0008 22H16.0007C14.8944 22 14.0006 22.8937 14.0006 24V29.5C14.0006 30.8813 12.8818 32 11.5005 32H8.00658C7.91283 32 7.81907 31.9937 7.72532 31.9875C7.65032 31.9937 7.57531 32 7.50031 32H6.50027C5.11959 32 4.00017 30.8813 4.00017 29.5V22.5C4.00017 22.4438 4.00204 22.3813 4.00579 22.325V17.975H2.00321C0.876286 17.975 0 17.0938 0 15.9688C0 15.4062 0.187758 14.9062 0.625651 14.4688L16.6507 0.501C17.0882 0.062625 17.5882 0 18.0257 0C18.4633 0 18.9633 0.12525 19.3446 0.438375L35.3015 14.4688C35.8015 14.9062 36.0577 15.4062 35.989 15.9688Z",
    fill: "#FF5870"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAktiv);
export default __webpack_public_path__ + "static/media/home-aktiv.67a840fe4eb071852d39a85911930274.svg";
export { ForwardRef as ReactComponent };